import { ExternalLink } from 'lucide-react';

export const WidgetFallback = () => (
  <div className="w-full min-w-[393px]">
    <div className="rounded-lg border border-border bg-card p-8 text-center space-y-4">
      <h2 className="text-xl font-medium">
        Cost of care data is temporarily unavailable
      </h2>
      <p className="text-base font-normal leading-relaxed text-muted-foreground">
        The cost of care tool is temporarily unavailable. You can access it directly on CareScout's website.
      </p>
      <a
        href="https://www.carescout.com/cost-of-care"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 text-sm font-medium text-primary underline underline-offset-4"
      >
        Visit CareScout's Cost of Care Tool
        <ExternalLink className="h-4 w-4" aria-hidden="true" />
      </a>
    </div>
  </div>
);
